export default __webpack_public_path__ + "static/media/science-card.72744b10.webp";